'use client';

export default function BrandStory() {
  return (
    <div className="mobile-right">
      <div className="mobile-content">
        {/* 引用内容 */}
        <div className="mobile-quote">
          <div className="quote-mark">&ldquo;</div>
          <p>
            我们开始这份事业，就是希望让每一位创作者不再只是为爱发电。我们相信，每一份才华都不该被辜负，每一个原创都值得拥有价值。
          </p>
        </div>
        
        {/* 创始人信息 */}
        <div className="founder-info">
          <div className="founder-avatar">
            <img
              src="/founder-avatar.jpg"
              alt="创始人"
              loading="eager"
              fetchPriority="high"
            />
          </div>
          
          <div>
            <div className="founder-name">孙晨颖</div>
            <div className="founder-title">基音 创始人</div>
          </div>
        </div>
      </div>
    </div>
  )
} 